<template>
  <div
      id="app"
      :class="{
      '--summary-active': summaryBehavior.showSummary,
    }"
  >
    <div v-if="ready">
      <headerComponent
          v-cloak
          v-if="readySession"
          v-show="showHeader"
          :onlyLanguage="onlyLanguage"
          :hideSummaryToggle="hideSummaryToggle"
          :showCurrencySelector="showCurrencySelector"
          :onpopstateEnabled="onpopstateEnabled"
          @readyLangSwitcher="readyLangSwitcher = true"
      />
      <stepper :key="$route.path" id="mainStepper"></stepper>
      <main>
        <template v-if="readyLangSwitcher">
          <transition name="fade" mode="out-in">
            <keep-alive>
              <router-view v-if="$route.meta.keepAlive"
                           id="view-active"
                           :key="$route.path"
              />
            </keep-alive>
          </transition>
          <transition name="fade" mode="out-in">
            <router-view v-if="!$route.meta.keepAlive"
                         id="view-active"
                         :key="$route.path"
            />
          </transition>
        </template>
      </main>
      <footerComponent v-if="showHeader && readyLangSwitcher"></footerComponent>
    </div>
    <vue-snotify></vue-snotify>
    <modal-container></modal-container>
    <toolbar v-if="showToolbar"></toolbar>
  </div>
</template>
<script>
import Vue from 'vue'
import axios from 'axios'
import breakpointPlugin from '../plugins/Breakpoint'
import ConfigProvider from '../plugins/ConfigProvider'
import VuejsDialog from 'vuejs-dialog'
import get from 'lodash/get'
import 'vuejs-dialog/dist/vuejs-dialog.min.css'
import { beautifyNames, getAirportName, getCityName, removeSeconds, getFormatedTime, formatNumberAmount, i18nParse, currentDateFormat, getParseAirports } from '../plugins/helpers.js'
import bus from '../services/Bus.js'
import vueMoment from '../plugins/vue-moment'
import vueSecureHTML from 'vue-html-secure'

Vue.use(vueMoment)
Vue.use(VuejsDialog)
Vue.use(breakpointPlugin)
Vue.use(vueSecureHTML)

Vue.mixin({
  methods: {
    $beautifyNames: beautifyNames,
    $getAirportName: getAirportName,
    $getCityName: getCityName,
    $removeSeconds: removeSeconds,
    $getFormatedTime: getFormatedTime,
    $formatNumberAmount: formatNumberAmount,
    $i18nParse: i18nParse,
    $currentDateFormat: currentDateFormat,
    $getParseAirports: getParseAirports
  }
})
import headerComponent from './Header/Header'
import footerComponent from './Footer/Footer'
import bootstrapCollapse from 'bootstrap/js/src/collapse.js'
import VueGtm from '@gtm-support/vue2-gtm'
import modalGeneric from 'core-lib/components/modal/ModalGeneric'
import modalContainer from 'core-lib/components/modal/ModalContainer'
import VTooltip from 'v-tooltip'
import stepper from './common/stepper/stepper.vue'
/* eslint-disable */
import jQuery from 'jquery'
window.jQuery = jQuery
window.$ = jQuery

import 'kiu-ds/fontawesome/all.css'
require('bootstrap/js/dist/dropdown')
require('bootstrap/js/dist/tab')
require('bootstrap/js/dist/modal')
require('../plugins/Toast')

Vue.use(VTooltip)
Vue.use(modalGeneric)
const mdBreakpoint = 768
const lgBreakpoint = 992
const xlBreakpoint = 1200


export default {
  name: 'Core',
  components: {
    headerComponent,
    footerComponent,
    modalContainer,
    stepper,
    // this prevent include the component in the build folder
    toolbar: () =>  process.env.NODE_ENV === 'development' ? import('./DebugToolbar/DebugToolbar') : undefined
  },
  inject: ['$validator'],
  props: {
    onlyLanguage: {
      type: Boolean,
      default: () => false
    },
    hideSummaryToggle: {
      type: Boolean,
      default: () => false
    },
    summaryBehavior: {
      type: Object,
      default: () => {
      }
    },
    showHeader: {
      type: Boolean,
      default: () => true
    },
    appName: {
      type: String,
      default: () => ''
    },
    showCurrencySelector: {
      type: Boolean,
      default: () => false
    },
    onpopstateEnabled: {
      type: Boolean,
      default: () => true
    },
    leaveHandlerEnabled: {
      type: Boolean,
      default: () => false
    }
  },
  data() {
    return {
      ready: false,
      readySession: false,
      readyLangSwitcher: false,
      showToolbar: false,
      reloadApp: false
    }
  },
  computed: {
    deviceResolution: function () {
      let resolution = 'M'
      if (screen.width >= mdBreakpoint && screen.width < lgBreakpoint) {
        resolution = 'T'
      } else if (screen.width >= lgBreakpoint) {
        resolution = 'D'
      }
      this.$store.commit('setDeviceType', resolution)
      return resolution
    },
    outsideSessionId: function () {
      return this.$route.query.id_session
    }
  },
  provide() {
    return {
      isDesktopXl: screen.width >= xlBreakpoint,
      isMobile: screen.width < mdBreakpoint,
      deviceType: this.deviceResolution
    }
  },
  methods: {
    setInterceptors: function () {
      axios.interceptors.response.use(null, (error) => {
        if (error.response.status === 403) {
          this.$store.dispatch('expireSession')
          this.$router.push('session-error')
        }
        if (error.response.status === 400) {
          const errorNumber = get(error, 'response.data.extended.extended.error_number')
          const apiMessage = get(error, 'response.data.extended.message')
          if (apiMessage) {
            error.response.data.message = apiMessage
          }
          if (errorNumber) {
            let i18nKey = `res_error_${errorNumber}`
            let error_msg = this.$t(i18nKey)
            if (error_msg !== i18nKey) {
              error.response.data.message = error_msg
            }
          }
        }
        return Promise.reject(error)
      })
    },
    getConfig: async function () {
      await ConfigProvider(this)
    },
    setStatics: function () {
      const staticUrl = this.$store.getters.getConfigUrls['staticUrl']
      if (!staticUrl) {
        console.warn('no static url')
      }
      document.querySelector('head').innerHTML += `<link rel="stylesheet" href="${staticUrl}" type="text/css"></link>`
    },
    setQueryCarrier: async function () {
      let carrierParam = this.$route.query.carrier
      if (carrierParam) {
        this.$store.commit('setCarrier', carrierParam)
      }
    },
    getSession: async function () {
      let sessionForce = this.outsideSessionId
      let sessionId = this.$store.getters.getSessionId
      let pathname = window.location.pathname.split('widget')[0]
      if (sessionForce) {
        await this.setQueryCarrier()
      }
      const firstFlow = this.$store.getters.getFlow ? this.$store.getters.getFlow[0].url : ''

      if (sessionForce || (!sessionId || (sessionId &&
              (this.$store.getters.getPathList.includes(firstFlow) || pathname === firstFlow))) ||
          (this.$store.getters.getFlow === null && this.$store.getters.getCarrier)) {
        const urlString = `?carrier=${this.$store.getters.getCarrier}&app=${this.$store.getters.getAppName}&init_data=1`
        let endpoint = this.outsideSessionId ? `metasearch_init/` : `init_data/${urlString}`
        let sessionUrl = `${this.$store.getters.getConfigUrls['apiUrl']}` + endpoint
        let headers = this.outsideSessionId ? {
          headers: {
            'Authorization': `Token  ${this.outsideSessionId}`
          }
        } : undefined
        await this.getWidgetData (sessionUrl, headers, sessionForce)
      }
      this.setAxiosHeaders()
      this.loadGTM()
      this.setApiVersion()
    },
    async getWidgetData (url, headers, sessionForce) {
      await axios.get(url, headers).then((res) => {
        window.sessionStorage.clear() // move this line here for removing sessionStorage when we are in the first flow
        res.data = res.data.response ? res.data.response : res.data
        this.$store.commit('setGeneralSettings', res.data.general_settings.response.ecommerce_general_settings)
        let flow = res.data.flow.response.flow

        this.$store.commit('setFlow', flow)
        if (!this.$store.getters.getPathList.includes(flow[0].url) && !this.outsideSessionId) {
          this.$router.push('session-error')
          this.$store.dispatch('expireSession')
        }
        // seteo widgetApps
        this.$store.commit('setWidgetApps', res.data.apps.response)
        this.$store.commit('setLangSwitcher', res.data.general_settings.response.ecommerce_general_settings.lang_switcher)

        // TODO "mejorar" actualizo el estado cuando vuelvo del iframe y actualizo antes el pathList
        if (res.data.state) {
          res.data.state.systemStore.configUrls = this.$store.getters.getConfigUrls
          res.data.state.systemStore.pathList = [window.location.pathname]

          res.data.search_data = res.data.state.systemStore.searchData
          this.$store.replaceState(Object.assign({}, this.$store.state, res.data.state))
        }

        if (get(res, 'data.search_data')) {
          this.$store.commit('setSearchData', res.data.search_data)
        }

        let sessionId = sessionForce || res.data.flow.response.session_key
        this.$store.commit('setSessionId', sessionId)
      })
          .catch(() => {
            console.log('Session & Flow Error.')
            this.$router.push('session-error')
          })
    },
    setApiVersion: function () {
      const apiVersion = get(this.$store.getters.getGeneralSettings, 'ecommerce_setup.api_version', "1")
      this.$store.commit('setApiVersion', apiVersion)
    },
    loadGTM: function () {
      const jj = this.$store.getters.getGeneralSettings
      if (this.$store.getters.getGTMCode === '' && jj) {
        this.$store.commit('setGTMCode', jj.ecommerce_setup.ecommerce_google_tag_manager_code)
      }
      this.insertGTM()
      // set urlRedirect
      this.$store.commit('setLogoUrlRedirect', get(jj, 'ecommerce_setup.logo_redirect_url'))
    },
    insertGTM: function () {
      try {
        if (this.$store.getters.getGTMCode && this.$store.getters.getGTMCode !== 'N') {
          Vue.use(VueGtm, {
            id: this.$store.getters.getGTMCode,
            defer: false,
            enabled: true,
            debug: false,
            loadScript: true,
            defer: false,
            compatibility: false,
            nonce: '',
            vueRouter: this.$router,
            trackOnNextTick: false,
          })
        }
      } catch (e) {
        console.log(`Error setting GTM/GA: ${e}`)
      }
    },
    setFakeFlow: function () {
      this.$store.commit('setPathList', [window.location.pathname])
      this.$store.dispatch('setSession', {
        "flow": [{"id": 7, "spaflow_id": 2, "url": "/searchflight/", "zorder": 0}, {
          "id": 8,
          "spaflow_id": 2,
          "url": "/flightresults/",
          "zorder": 1
        }, {"id": 9, "spaflow_id": 2, "url": "/travellerdetails/", "zorder": 2}, {
          "id": 10,
          "spaflow_id": 2,
          "url": "/extraservices/",
          "zorder": 3
        }, {"id": 11, "spaflow_id": 2, "url": "/purchase/", "zorder": 4}, {
          "id": 12,
          "spaflow_id": 2,
          "url": "/endflow/",
          "zorder": 5
        }],
        "session_key": "fake_session"
      })
      this.$store.commit('setLangSwitcher', {
        "current": {"flag": false, "icon": "", "label": true, "label_prefix": "language_"},
        "languages": {"flag": false, "items": [{"lang": "en"}, {"lang": "es"}], "label": true, "label_prefix": "lang_"}
      })
    },
    pushState: function () {
      history.pushState(null, window.location.pathname, window.location.pathname)
    },
    onpopstate: function () {
      try {
        if (this.onpopstateEnabled) {
          // history.pushState(null, window.location.pathname, window.location.pathname)
          this.pushState()
          console.log('window.onpopstate will to enable')
          window.addEventListener('popstate', (event) => {
            event.preventDefault()
            this.$openModalDialog({
              title: this.$t('browser_action_back_alert_title'),
              text: 'browser_action_back_alert_message',
              modalProps: { allowedClose: false },
              buttons: [
                {
                  label: 'back_button_do_not_continue',
                  classes: 'btn-primary',
                  handler: () => {
                    this.$closeModal()
                    this.pushState()
                  }
                },
                {
                  label: 'back_button_continue',
                  handler: () => {
                    if (this.leaveHandlerEnabled) {
                      bus.$emit('leaving', this.handleRedirect)
                      this.$closeModal()
                    } else {
                      this.handleRedirect()
                    }
                  }
                }
              ]
            })
          }, false)
        }
      } catch (e) {
        console.log('.....error....', e)
      }
    },
    handleRedirect: function () {
      const appName = this.$store.getters.getAppName
      try{
        this.$store.dispatch('goBackSpa')
      }catch (error) {
        window.location.href = this.$store.getters.getLogoUrlRedirect ||
            `${window.location.protocol}//${window.location.hostname}/booking`
      }
    },
    setAxiosHeaders: function () {
      axios.defaults.headers.common['Authorization'] = 'Token ' + this.$store.getters.getSessionId
      axios.defaults.headers.common['Carrier'] = this.$store.getters.getCarrier
    },
    closeApp(e, axios) {
      // IMPORTANTE, SOLO SE DISPARA SI CAMBIO ALGO EN EL DOCUMENTO 
      // POR EJ. SELECCIONAR ALGO 
      if (!this.$store.getters.getConfigUrls?.disabledUserExitNotify) {
        // determina si sigue en el flujo o se va de la App
        const isFlowAction = this.$store.getters.isLoading
        // const isPurchaseSPA = (window.location.pathname.replaceAll('/', '') === 'purchase')

        if (!isFlowAction && !this.reloadApp) {
          e.preventDefault()
          // Chrome requires returnValue to be set
          // Included for legacy support, e.g. Chrome/Edge < 119
          e.returnValue = true

          // si agrego el asyn/await aca, no se muestra la modal
          this.callReportUserExit(axios)

        }
      }
      this.reloadApp = false
    }, 
    async callReportUserExit (axios) {
      const response = await this.reportUserExit(axios)
    },
    reportUserExit(axios){
      return new Promise((resolve, reject) => {
         try {
          const url = this.$store.getters.getConfigUrls.apiPost + '/report_user_exit/'
          const data = axios.post(url, {spa_name: window.location.pathname.replaceAll('/', '')})
          resolve(data)
        }
        catch(err){
            reject(err)
          }
      })
    },
    keyDownHandle (e){
      if ((e?.key === 'F5') || ((e.key === 'r' || e.key === 'R') && e.ctrlKey) || ['Meta', 'r'].includes(e.key)) {
        this.reloadApp = true
      }
    }
  },
  created () {
    this.setInterceptors()
  },
  async mounted () {
    const env = process.env
    if (env.VUE_APP_SHOW_TOOLBAR === 'true' && env.NODE_ENV === 'development') {
      this.showToolbar = true
    }
    await this.getConfig()
    if (env.VUE_APP_VALIDATE_SESSION !== 'false') {
      await this.getSession()
    } else {
      // localStorage.clear()
      this.setFakeFlow()
    }
    this.setStatics()
    this.onpopstate()
    this.readySession = true
    this.ready = true
    this.$emit('config-ready')
    window.addEventListener("beforeunload", (e) => {this.closeApp(e, axios)})
    window.addEventListener("keydown",(e) => {this.keyDownHandle(e)})
  }
}
</script>

<style lang="sass">
@import '../assets/sass/global'
\:root
  --color-nav: var(--color-surface)
  --color-onNav: var(--color-onSurface)
.dg-btn--ok
  background-color: var(--color-primary) !important
  border-color: var(--color-primary) !important
  color: var(--color-onPrimary) !important
  font-weight: 100 !important
.dg-btn--cancel
  color: var(--color-onBackground) !important
  background-color: transparent !important
  border: 1px solid var(--color-overlay-30) !important
  font-weight: 100 !important
.snotify
  z-index: 9999999 !important
</style>
